{
  "meta": {
    "title": "Cycling Zone · the browser cycling manager where strategy beats spending",
    "description": "Build a team, bid on riders in live auctions, set your tactics, and race a full season. A free, browser-based cycling manager game. No pay-to-win."
  },
  "nav": {
    "discordLabel": "Discord",
    "languageLabel": "Language",
    "login": "Log in",
    "signup": "Sign up",
    "skipToContent": "Skip to content"
  },
  "hero": {
    "badge": "Open beta · Free to play",
    "title": "A cycling manager built for the long game.",
    "subtitle": "Build your team, bid on riders in live auctions, and make every call across a full season. Climb the divisions, right in your browser.",
    "ctaPlay": "Create your team",
    "ctaDiscord": "Join the Discord",
    "ctaEmail": "Get the launch email",
    "trustFree": "Free to play",
    "trustNoCard": "No download",
    "trustBrowser": "Runs in your browser"
  },
  "signature": {
    "kicker": "Inside the game",
    "stageTitle": "Stage 14 · Summit finish",
    "distanceLabel": "Distance",
    "distanceValue": "182 km",
    "climbLabel": "Final climb",
    "climbValue": "HC · 14.2 km at 7.8%",
    "classificationTitle": "General classification",
    "gapHeader": "Gap",
    "jerseyYellow": "Race leader",
    "jerseyGreen": "Points leader",
    "jerseyPolka": "Mountains leader",
    "sampleNote": "Sample data. Live standings update as the race unfolds."
  },
  "how": {
    "kicker": "How you play",
    "title": "Five decisions, every season",
    "rows": [
      {
        "no": "01",
        "title": "Build your team",
        "body": "Pick a roster that fits your strategy. Climbers for the mountains, sprinters for the flat, a captain to build around.",
        "data": "Lead a full roster, not just a star"
      },
      {
        "no": "02",
        "title": "Bid in live auctions",
        "body": "Compete for riders in real-time auctions against other managers. Read the room, time your bid, do not overpay.",
        "data": "Live, manager-versus-manager bidding"
      },
      {
        "no": "03",
        "title": "Develop your riders",
        "body": "Train your riders to sharpen their strengths, and bring young talent up through your academy. Today's prospect can become next season's star.",
        "data": "A youth academy to grow your own stars"
      },
      {
        "no": "04",
        "title": "Set your tactics",
        "body": "Pick your captain, send riders up the road, and decide who chases and who saves their legs for the finish.",
        "data": "Tactics that change the result"
      },
      {
        "no": "05",
        "title": "Race the season",
        "body": "Follow your team through stage races and one-day races across a full season, then build for the next season.",
        "data": "Race your way up the divisions"
      }
    ]
  },
  "different": {
    "kicker": "Not your usual manager game",
    "title": "Built on one promise",
    "fairness": "The game must be fair for everyone. Real money can't buy better riders, faster training, or better results.",
    "cards": [
      {
        "title": "Shaped by the community",
        "body": "One developer, building in public. Your feedback decides what gets built next, and every change ships where you can see it."
      },
      {
        "title": "Free to play",
        "body": "The full game is free. Sign up, build a team, and compete without paying for anything that affects the outcome."
      },
      {
        "title": "No install",
        "body": "It runs in your browser, on your phone or your laptop. Nothing to download, nothing to update."
      }
    ]
  },
  "discord": {
    "kicker": "Join in",
    "title": "The game is built in the open",
    "body": "Cycling Zone started as one idea: a cycling manager where you don't just click through numbers, but actually build something over a season. I'm making it on my own, in the open, season by season. The Discord is where I share what I'm working on before it ships, where new managers get a hand finding their feet, and where your feedback decides what I build next. It's not finished, and it gets better every week. You come for the racing. You stay for the people. Bring your team, share your thoughts, and help shape where it goes.",
    "cta": "Open the Discord"
  },
  "waitlist": {
    "kicker": "Prefer email?",
    "title": "Get the launch email",
    "body": "Leave your email, and I'll send you one message when the next season starts. No newsletter, no noise.",
    "emailLabel": "Email",
    "emailPlaceholder": "you@example.com",
    "nameLabel": "First name",
    "nameOptional": "optional",
    "namePlaceholder": "What should I call you?",
    "consentBefore": "I agree to be contacted about the launch and accept the ",
    "consentLink": "privacy policy",
    "consentAfter": ".",
    "privacyPath": "/privacy-policy",
    "submit": "Notify me at launch",
    "submitting": "Adding you to the list...",
    "disclaimer": "One email at launch. Unsubscribe any time.",
    "successTitle": "You are on the list",
    "successBody": "Thanks. I'll email you once when the next season starts. In the meantime, the Discord is the best place to follow along.",
    "successDiscord": "Join the Discord",
    "errors": {
      "emailRequired": "Please enter your email.",
      "emailInvalid": "That email does not look right.",
      "consent": "Please accept the privacy policy to continue.",
      "duplicate": "You are already on the list.",
      "rls": "Something blocked the sign-up. Please try again.",
      "network": "Network error. Please check your connection and try again.",
      "unknown": "Something went wrong. Please try again."
    }
  },
  "faq": {
    "kicker": "Questions",
    "title": "Good to know",
    "items": [
      {
        "q": "Is it really free?",
        "a": "Yes. The full game is free to play. You can sign up, build a team, and compete against other managers without paying for anything."
      },
      {
        "q": "Is it pay-to-win?",
        "a": "No. Real money can't buy results. The best manager wins, not the biggest spender."
      },
      {
        "q": "When does the season start?",
        "a": "Cycling Zone is in open beta now, with a fresh season opening soon. Join the Discord or leave your email, and I'll let you know the moment it starts."
      },
      {
        "q": "Do I need to install anything?",
        "a": "No. It runs in your browser on desktop and mobile. There is nothing to download."
      }
    ]
  },
  "footer": {
    "tagline": "A browser-based cycling manager.",
    "privacy": "Privacy",
    "discord": "Discord",
    "rights": "Cycling Zone",
    "exploreHeading": "Explore",
    "explore": {
      "howItWorks": "How it works",
      "compare": "Cycling Zone vs Pro Cycling Manager",
      "help": "Help",
      "rules": "Rules",
      "roadmap": "Roadmap",
      "patchNotes": "Patch notes",
      "founderSupporter": "Founder",
      "terms": "Terms",
      "privacy": "Privacy"
    }
  }
}
